import { Link, Navigate } from "react-router-dom";
import SideNav from "../../../../components/dashboard/Sidebar";
import { connect } from "react-redux";
import {
  list_orders,
  list_orders_page,
} from "../../../../redux/actions/orders";
import { useEffect } from "react";
import { IconEye } from "@tabler/icons-react";
import SetPagination from "../../../../components/pagination/SetPagination";

function DashboardUserOrder({
  isAuthenticated,
  list_orders,
  orders,
  list_orders_page,
  count,
}) {
  useEffect(() => {
    list_orders();
  }, [list_orders]);

  if (!isAuthenticated) return <Navigate to="/" />;

  return (
    <SideNav>
      <div className="container mx-auto px-4 sm:px-8">
        <div className="flex justify-between items-center mt-4">
          <h1 className="text-2xl font-semibold text-gray-900">Sales Orders</h1>
        </div>

        <div className="mt-8">
          <div className="flex flex-col">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200 text-center">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Transaction ID
                        </th>
                        <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Date Issued
                        </th>
                        <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Amount
                        </th>
                        <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Shipping Price
                        </th>
                        <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Status
                        </th>
                        <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Address
                        </th>
                        <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {orders && orders.length > 0 ? (
                        orders.map((order) => (
                          <tr key={order.transaction_id}>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {order.transaction_id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {new Date(order.date_issued).toLocaleString()}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              ${parseFloat(order.amount).toFixed(2)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {order.shipping_price
                                ? `$${parseFloat(order.shipping_price).toFixed(
                                    2,
                                  )}`
                                : "N/A"}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {/* Mostrar el estado de la orden con el color correspondiente */}
                              {order.status === "not_processed" ? (
                                <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-700 ring-1 ring-inset ring-yellow-700">
                                  Not Processed
                                </span>
                              ) : order.status === "processed" ? (
                                <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700">
                                  Processed
                                </span>
                              ) : order.status === "shipped" ? (
                                <span className="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700">
                                  Shipped
                                </span>
                              ) : order.status === "delivered" ? (
                                <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-700">
                                  Delivered
                                </span>
                              ) : order.status === "cancelled" ? (
                                <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-700">
                                  Cancelled
                                </span>
                              ) : order.status === "received" ? (
                                <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-700">
                                  Received
                                </span>
                              ) : (
                                <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-500 ring-1 ring-inset ring-gray-500">
                                  Unknown Status
                                </span>
                              )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {order.address_line_1} {order.address_line_2}
                            </td>

                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              <div className="flex justify-center space-x-2">
                                <Link
                                  className="p-1 text-white bg-blue-500 rounded-full hover:bg-blue-600"
                                  to={`/dashboard/client-orders/${order.transaction_id}`}
                                >
                                  <IconEye size={20} />
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                          >
                            No orders found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <SetPagination
                    count={count}
                    list_function={list_orders_page}
                    type="medium"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SideNav>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
  orders: state.Orders.orders,
  count: state.Orders.count,
});

export default connect(mapStateToProps, { list_orders, list_orders_page })(
  DashboardUserOrder,
);
